// extracted by mini-css-extract-plugin
export default {"brand":"Navigation_brand__AncL3","navLink":"Navigation_navLink__jXeML"};